<template>
    <div>
        <div>
            <div class="flex" style="width: 100%;">
                <vs-button @click="popupAddMoreQuestions = true;" icon="add" type="border" color="primary" class="vs-button mt-3 p-2 mr-3">Agregar otra pregunta</vs-button>
                <vs-button @click="rellenarPreguntas();" type="border" color="danger" class="vs-button mt-3 p-2 mr-3"><i class="fa-solid fa-circle-half-stroke"></i> Rellenar: <b>Grupo {{ grupoSelect}} </b></vs-button>
                <vs-button @click="traerEvaluacionEstudiante(0);" type="border" color="danger" class="vs-button mt-3 p-2 mr-3"><i class="fa-solid fa-file-word"></i> Exportar: <b>Word </b></vs-button>
                <vs-button @click="traerEvaluacionEstudiante(1);" type="border" color="danger" class="vs-button mt-3 p-2 mr-3"><i class="fa-solid fa-file-pdf"></i> Exportar: <b>PDF </b></vs-button>
            </div>
            <br>
            <!--vs radios con el arrayGrupos-->
            <ul class="flex mt-1">
                <li class="mr-3">
                <vs-radio v-model="grupoSelect" @input="filterPregruntas();" vs-name="radios1grupoSelect" vs-value="1">Grupo 1</vs-radio>
                </li>
                <li class="mr-3" v-if="ObjectSelected.grupos > 1">
                <vs-radio v-model="grupoSelect" @input="filterPregruntas();" vs-name="radios1grupoSelect" vs-value="2">Grupo 2</vs-radio>
                </li>
                <li class="mr-3" v-if="ObjectSelected.grupos > 2">
                <vs-radio v-model="grupoSelect" @input="filterPregruntas();" vs-name="radios1grupoSelect" vs-value="3">Grupo 3</vs-radio>
                </li>
                <li class="mr-2" v-if="ObjectSelected.grupos > 3">
                <vs-radio v-model="grupoSelect" @input="filterPregruntas();" vs-name="radios1grupoSelect" vs-value="4">Grupo 4</vs-radio>
                </li>
            </ul>
            <!--TABLA-->
            <TablePreguntasVue :listaPreguntas="tmpPreguntas" :listado="Number(1)" :ObjectSelected="ObjectSelected" :acciones="Number(1)" :btnquitar="Number(1)" @openConfirmDelete="openConfirmDelete"/>
        </div>
        <!--popup-->
        <vs-popup :active.sync="popupAddMoreQuestions" title="Agregar mas preguntas" fullscreen>
            <TablePreguntasVue :listaPreguntas="arrayMoreQuestions" :acciones="Number(1)" :btnAsignar="Number(1)" @asignarPregunta="asignarPregunta" :ObjectSelected="ObjectSelected"/>
        </vs-popup>
        <!--popup resumen ingreso-->
        <vs-popup :active.sync="popupResumenIngreso" :title="'Resumen preguntas ingresadas del grupo '+ grupoSelect">
            <h5 class="text-center">Resumen de preguntas ingresadas del grupo {{ grupoSelect }}</h5>
            <p class="text-center">Preguntas ingresadas: {{ preguntasIngresadas }}</p>
            <p class="text-center" v-if="preguntasNoIngresadas > 0">Preguntas no ingresadas: {{ preguntasNoIngresadas }}</p>
            <!--boton de aceptar-->
            <div class="flex justify-center">
                <vs-button @click="popupResumenIngreso = false;" color="success" class="mt-5">Aceptar</vs-button>
            </div>  
        </vs-popup>
        <!--modales-->
        <!--exportar word-->
        <div v-if="mostrarExportWord">
            <ExportEvaluacionVue :arrayPreguntas="arrayPreguntasEvaluacion" :setEvaluacion="ObjectSelected" @changeExport="changeExport" :grupoSelect="grupoSelect"/>
        </div>
        <!--exportar pdf-->
        <div v-if="mostrarExportPDF">
            <ExportEvaluacionPdfVue :arrayPreguntas="arrayPreguntasEvaluacion" :setEvaluacion="ObjectSelected" @changeExport="changeExport" :grupoSelect="grupoSelect"/>
        </div>
    </div>
</template>
<script>
import GeneralMixin from '../../../../mixins/GeneralMixin';
import TablePreguntasVue from './TablePreguntas.vue';
const ExportEvaluacionVue = () => import('./exports/ExportEvaluacion.vue');
const ExportEvaluacionPdfVue = () => import('./exports/ExportEvaluacionPdf.vue');
export default{
    mixins: [GeneralMixin],
    components: {
        TablePreguntasVue,
        ExportEvaluacionVue,
        ExportEvaluacionPdfVue,
    },
    data(){
        return{
            usuario:[],
            arrayPreguntas: [],
            tmpPreguntas: [],
            arrayGrupos:[],
            arrayMoreQuestions:[],
            grupoSelect:1,
            popupAddMoreQuestions:false,
            idgrupoEvaluacion:0,
            preguntasIngresadas:0,
            preguntasNoIngresadas:0,
            popupResumenIngreso:false,
            //variables para exportar
            mostrarExportWord:false,
            arrayPreguntasEvaluacion:[],
            mostrarExportPDF:false,
            //fin variables para exportar
        }
    },
    props:{
        id:             { type: Number, default: 0 },
        ObjectSelected: { type: Object, default: () => {} }
    },
    created(){
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted(){
        let me = this;
        me.arrayGrupos = []
        //GRUPOS
        for (let i = 0; i < me.ObjectSelected.grupos; i++) { me.arrayGrupos.push({id:i +1 , nombre:`Grupo ${i}`});  }
        //desafios az
        if(me.ObjectSelected.origen == 0) { me.idgrupoEvaluacion = 1;}
        //mis desafios
        if(me.ObjectSelected.origen == 1) { me.idgrupoEvaluacion = 6;}
        this.getPreguntasEvaluacion();
    },
    methods:{
        changeExport(){
            let me = this;
            me.mostrarExportWord = false
            me.mostrarExportPDF  = false
        },
        getPreguntasEvaluacion(){
            let me = this;
            me.arrayPreguntas = [];
            const { idlibro, unidades } = this.ObjectSelected;
            me.$vs.loading();
            me.$http.get(this.$server_url+`evaluacion?getQuestions=1&idlibro=${ idlibro }&unidades=${ unidades }&idEvaluacion=${ this.id }`)
                .then(function (response) {
                    me.$vs.loading.close();
                    if(response.data.status == '0'){ 
                        me.f_notificaciones(response.data.message, "danger");
                         return;
                    }
                    me.arrayPreguntas = response.data;
                    me.filterPregruntas();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se pudieron cargar las preguntas para la evaluación", "danger");
                })
        },
        filterPregruntas(){
            let me = this;
            me.tmpPreguntas =  me.arrayPreguntas.filter((pregunta) => pregunta.grupo == me.grupoSelect);
            me.getExplorarMoreQuestions();
        },
        getExplorarMoreQuestions(){
            let me = this;
            me.arrayMoreQuestions = []
            me.$vs.loading();
            me.$http.get(this.$server_url+`evaluacion?getExplorarMoreQuestions=1&idEvaluacion=${ this.id }&idgrupo=${ me.idgrupoEvaluacion }`)
                .then(function (response) {
                    let datos = []
                    //desarfios az
                    if(me.idgrupoEvaluacion == 1) { datos = response.data; }
                    //mis desafios
                    if(me.idgrupoEvaluacion == 6) { datos = response.data.filter( p => p.id_editor == me.usuario.idusuario ); }
                    //del array tmpPreguntas filtrar las preguntas que no esten en el array datos
                    me.arrayMoreQuestions = datos.filter(objeto1 => {
                        return !me.tmpPreguntas.some(objeto2 => objeto2.id === objeto1.id);
                    });
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se cargaron las preguntas para la evaluación", "danger");
                })
        },
        asignarPregunta(e){
            let me = this;
            me.$vs.loading();
            let formData = new FormData();
            formData.append('idEvaluacion', this.id);
            formData.append('idPregunta',    e.id);
            formData.append('grupo',        this.grupoSelect);
            formData.append('guardarPregunta', 1)
            me.$http.post(this.$server_url+'EvaluacionMetodosPost', formData)
                .then(function (response) {
                    me.$vs.loading.close();
                    if(response.data.status == '0'){ 
                        me.f_notificaciones(response.data.message, "danger");
                        return;
                    }
                    me.f_notificaciones("Pregunta asignada", "success");
                    me.getPreguntasEvaluacion();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se pudo asignar la pregunta", "danger");
                })
        },
        rellenarPreguntas(){
            let me = this 
            if(me.arrayMoreQuestions.length == 0){
               me.f_notificaciones("No hay preguntas para rellenar", "danger");
                return;
            }
            me.preguntasIngresadas      = 0
            me.preguntasNoIngresadas    = 0
            //api post EvaluacionMetodosPost
            let formData = new FormData();
            formData.append('idEvaluacion',     this.id);
            formData.append('grupo',            this.grupoSelect);
            formData.append('arrayPreguntas',   JSON.stringify(this.arrayMoreQuestions));
            formData.append('rellenarPreguntas', 1)
            me.$vs.loading();
            me.$http.post(this.$server_url+'EvaluacionMetodosPost', formData)
                .then(function (response) {
                    me.$vs.loading.close();
                    if(response.data.status == '0'){ 
                        me.f_notificaciones(response.data.message, "danger");
                        return;
                    }
                    me.preguntasIngresadas   = response.data.ingresados
                    me.preguntasNoIngresadas = response.data.noIngresados
                    me.popupResumenIngreso   = true
                    me.f_notificaciones("Preguntas rellenadas", "success");
                    me.getPreguntasEvaluacion();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se pudieron rellenar las preguntas", "danger");
                })
        },
        traerEvaluacionEstudiante(tipoE){
            let me = this;
            let formData = new FormData();
            formData.append('idEvaluacion',         this.id);
            formData.append('grupo',                this.grupoSelect);
            formData.append('getEvaluacionGrupo',   1)
            me.$vs.loading();
            me.$http.post(this.$server_url+'EvaluacionMetodosPost', formData)
            .then(function (response) {
                me.$vs.loading.close();
                if(response.data.status == '0'){ 
                    me.f_notificaciones(response.data.message, "danger");
                    return;
                }
                if(response.data.length == 0){
                    me.f_notificaciones("No hay preguntas para la evaluación", "danger");
                    return;
                }
                me.arrayPreguntasEvaluacion = response.data;
                if(tipoE == 0) { me.mostrarExportWord = true; }
                if(tipoE == 1) { me.mostrarExportPDF  = true; }
            })
            .catch(function () {
                me.$vs.loading.close();
                me.f_notificaciones("No se pudo traer la evaluación", "danger");
            })
        },
        openConfirmDelete(e){
            let me = this;
            me.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Quitar pregunta',
                text: '¿Está seguro que desea quitar la pregunta?',
                acceptText: 'Aceptar',
                cancelText: 'Cancelar',
                accept: () => {
                    me.quitarPregunta(e);
                }
            });
        },
        quitarPregunta(e){
            let me = this;
            me.$vs.loading();
            let formData = new FormData();
            formData.append('idEvaluacion',             this.id);
            formData.append('idPregunta',               e.id);
            formData.append('grupo',                    e.grupo);
            formData.append('quitarPreguntaEvaluacion', 1)
            me.$http.post(this.$server_url+'EvaluacionMetodosDelete', formData)
                .then(function (response) {
                    me.$vs.loading.close();
                    if(response.data.status == '0'){ 
                        me.f_notificaciones(response.data.message, "danger");
                        return;
                    }
                    me.f_notificaciones("Pregunta quitada", "success");
                    me.getPreguntasEvaluacion();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se pudo quitar la pregunta", "danger");
                })
        }
    }
}
</script>
<style scoped>
.adjunto{
    margin: 5px 10px;
    color:#3E4448;
    background-color:#EBF3F8;
    width: 30%;
    height: 53px;
    cursor: pointer;
    transition: 0.5s ease-in-out;
    border-radius: 5px;
}
.adjunto:hover{
    opacity: 0.8;
}
</style>